import { render, staticRenderFns } from "./ApproachTable.vue?vue&type=template&id=22a3cd08"
import script from "./ApproachTable.vue?vue&type=script&lang=js"
export * from "./ApproachTable.vue?vue&type=script&lang=js"
import style0 from "./ApproachTable.vue?vue&type=style&index=0&id=22a3cd08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports